var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuoteEmailed',{attrs:{"header":"Rideshare - Quote Emailed","title":"Rideshare","bodyTitle":"Quote Emailed","bodyText":"A new Rideshare quote has been sent on your behalf.","newQuoteAction":_vm.newQuote,"viewQuotesAction":_vm.viewQuotes}})}
var staticRenderFns = []

export { render, staticRenderFns }